
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/refund-policy",
      function () {
        return require("private-next-pages/help/refund-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/refund-policy"])
      });
    }
  